var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSortUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 14.5118C2.70312 14.9721 3.07622 15.3452 3.53646 15.3452H10.2031C10.6634 15.3452 11.0365 14.9721 11.0365 14.5118C11.0365 14.0516 10.6634 13.6785 10.2031 13.6785H3.53646C3.07622 13.6785 2.70312 14.0516 2.70312 14.5118Z",
    fill: "#4A5467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 10.3452C2.70312 10.8054 3.07622 11.1785 3.53646 11.1785H8.53646C8.9967 11.1785 9.36979 10.8054 9.36979 10.3452C9.36979 9.88494 8.9967 9.51184 8.53646 9.51184H3.53646C3.07622 9.51184 2.70312 9.88494 2.70312 10.3452Z",
    fill: "#4A5467"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 6.17851C2.70312 6.63875 3.07622 7.01184 3.53646 7.01184H6.86979C7.33003 7.01184 7.70312 6.63875 7.70312 6.17851C7.70312 5.71827 7.33003 5.34518 6.86979 5.34518H3.53646C3.07622 5.34518 2.70312 5.71827 2.70312 6.17851Z",
    fill: "#4A5467"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7031 8.67851C17.7031 8.67851 17.7031 8.67851 17.7031 8.67851C18.0286 8.35307 18.0286 7.82544 17.7031 7.5C17.7031 7.5 17.7031 7.5 17.7031 7.5L16.3816 6.17851C15.8261 5.62296 15.5483 5.34518 15.2031 5.34518C14.8579 5.34518 14.5802 5.62296 14.0246 6.17851L12.7031 7.5C12.7031 7.5 12.7031 7.5 12.7031 7.5C12.3777 7.82544 12.3777 8.35307 12.7031 8.67851C13.0286 9.00395 13.5562 9.00395 13.8816 8.67851V8.67851L14.3698 8.19036V15.3452H16.0365V8.19036L16.5246 8.67851C16.5246 8.67851 16.5246 8.67851 16.5246 8.67851C16.8501 9.00395 17.3777 9.00395 17.7031 8.67851C17.7031 8.67851 17.7031 8.67851 17.7031 8.67851Z",
    fill: "#4A5467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSortUp);
export default __webpack_public_path__ + "static/media/ic-sort-up.2e73174eeec6d5ea33ac81e0cbb76eae.svg";
export { ForwardRef as ReactComponent };